import React from 'react'
import PropTypes from 'prop-types'
import * as bubbleUi from 'mage-deps/@klarna/bubble-ui'
import { SelectorDirect } from 'mage-deps/@klarna/bubble-ui'
import { EducationAnalytics, useEducationAnalytics } from 'education-tools'
import { useHelpContext } from '../HelpfulQuestionMark/hooks'

OrientationItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      target: PropTypes.object.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired
    })
  ).isRequired
}

export default function OrientationItems({ items }) {
  const { navigation } = useHelpContext()

  const category = 'orientation/item'
  const referenceType = 'orientation-item'

  const trackClick = useEducationAnalytics({ category, referenceType, action: 'click' })

  const options = items.map(item => ({
    label: item.title,
    description: item.description,
    icon: getIcon(item.icon),
    value: item
  }))

  return [
    ...items.map(item => (
      <EducationAnalytics
        key={item.id}
        category={category}
        action="print"
        label={item.title}
        referenceType={referenceType}
        referenceId={item.id}
      />
    )),
    <SelectorDirect key="selector" onSelect={onSelect(navigation, trackClick)} options={options} />
  ]
}

const onSelect = (navigation, trackClick) => ({ id, title, target }) => {
  trackClick({ label: title, referenceId: id })

  switch (target.contentType) {
    case 'UHQMArticle':
      navigation.push('article', { articleSlug: target.slug })
      break
    case 'UHQMTour':
      navigation.push('tour', { tourSlug: target.slug })
      break
  }
}

function getIcon(icon) {
  const Icon = bubbleUi[icon]
  return Icon ? <Icon /> : null
}
